import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import "../styles/Landing.css";
import Home from "./Home";

const Landing = ({ restaurantID, menuObj, DietaryFilters, Dietary, setDietary, Layout, Labels, LandingPage }) => {

  const buttonRef = useRef(null);
  const [searchParams] = useSearchParams();
  const tableId = searchParams.get("utm_id");
  localStorage.setItem(`${restaurantID}_S9Table`, tableId);


  useEffect(() => {
    const existingUser = JSON.parse(
      localStorage.getItem(`${restaurantID}_s9userinfo`) || "null"
    );

    const redirectUrl = LandingPage?.NavigateTo
      ? `https://${window.location.hostname}${LandingPage.NavigateTo}`
      : `https://${window.location.hostname}/`;

    // User already exists
    if (existingUser?.name && existingUser?.phone) {
      window.location.replace(redirectUrl);
      return;
    }

    // Ask for name
    let name = "";
    while (!name) {
      const input = window.prompt("Enter your name:");

      if (input === null) return;

      if (input.trim().length >= 2) {
        name = input.trim();
      } else {
        alert("Please enter a valid name.");
      }
    }

    // Ask for phone
    const phoneRegex = /^[6-9]\d{9}$/;
    let phone = "";

    while (!phone) {
      const input = window.prompt("Enter your 10-digit phone number:");

      if (input === null) return;

      if (phoneRegex.test(input.trim())) {
        phone = input.trim();
      } else {
        alert("Please enter a valid 10-digit phone number.");
      }
    }

    localStorage.setItem(
      `${restaurantID}_s9userinfo`,
      JSON.stringify({ name, phone })
    );

    window.location.replace(redirectUrl);
  }, [LandingPage, restaurantID]);


  return (
    <div className="proxy-proxyContainer">
      {LandingPage?.PageType === "Image Banner" ?
        <>
          <div className="proxy-proxyWindow" style={{ background: `URL(${LandingPage?.Content})`, backgroundPosition: "top", backgroundSize: "105%" }}>
            <a className="proxy-proxyButton" ref={buttonRef} href={LandingPage?.NavigateTo ? `https://${window.location.hostname}${LandingPage?.NavigateTo}` : `https://${window.location.hostname}/`}>
              <div className="proxy-inner">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="27px"
                  viewBox="0 -960 960 960"
                  width="27px"
                  fill="#291A02"
                >
                  <path d="m250.67-177-73.34-73.67 229-229.33-229-228.67 73.34-74.66L480-554.67l229.33-228.66 73.34 74.66L554.33-480l228.34 229.33L709.33-177 480-405.67 250.67-177Z" />
                </svg>
              </div>
            </a>
          </div>
          <div className="proxy-backdrop">
            <Home restaurantID={restaurantID} Layout={Layout} Labels={Labels} menuObj={menuObj} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} />
          </div>
        </>
        :
        <div className="proxy-loader">
          <a className="loader-proxy-proxyButton" ref={buttonRef} href={LandingPage?.NavigateTo ? `https://${window.location.hostname}${LandingPage?.NavigateTo}` : `https://samudaya.ettarracoffee.com/`}>
            <div className="proxy-inner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="27px"
                viewBox="0 -960 960 960"
                width="27px"
                fill="#291A02"
              >
                <path d="m250.67-177-73.34-73.67 229-229.33-229-228.67 73.34-74.66L480-554.67l229.33-228.66 73.34 74.66L554.33-480l228.34 229.33L709.33-177 480-405.67 250.67-177Z" />
              </svg>
            </div></a>
          <div className="proxy-spinner"></div>
          <p>Loading...</p>
        </div>
      }
    </div>
  );
};


export default Landing;
